export default "__VITE_ASSET__5b0678dd__"